import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx-js-style'
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  export(
  data: any[],
  displayedColumns: { key: string; value: string }[],
  fileName: string = 'export.xlsx',
  title: string = 'Report'
) {
  if(data.length==0) {
    Swal.fire('Info','Please Select atleast one Data to Export.','info')
    return
  }
  const wb: XLSX.WorkBook = XLSX.utils.book_new();

  const exportColumns = displayedColumns.filter(col => 
    col.key !== 'action' && col.key !== 'checkbox' && col.key !== 'select'
  );

  const exportData = data.map(row => {
    const newRow: any = {};
    exportColumns.forEach(col => {
      newRow[col.value] = row[col.key] ?? '';
    });
    return newRow;
  });

  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

  const colCount = exportColumns.length;

  const oldRef = XLSX.utils.decode_range(ws['!ref']!);
  ws['!ref'] = XLSX.utils.encode_range({
    s: { r: 0, c: 0 },
    e: { r: oldRef.e.r + 1, c: oldRef.e.c }
  });

  for (let R = oldRef.e.r; R >= oldRef.s.r; --R) {
    for (let C = oldRef.s.c; C <= oldRef.e.c; ++C) {
      const oldAddr = XLSX.utils.encode_cell({ r: R, c: C });
      const newAddr = XLSX.utils.encode_cell({ r: R + 1, c: C });
      ws[newAddr] = ws[oldAddr];
      if (R === oldRef.s.r) delete ws[oldAddr];
    }
  }

  const border = {
    top: { style: 'thin', color: { rgb: '000000' } },
    bottom: { style: 'thin', color: { rgb: '000000' } },
    left: { style: 'thin', color: { rgb: '000000' } },
    right: { style: 'thin', color: { rgb: '000000' } }
  };

  if (!ws['!merges']) ws['!merges'] = [];
  ws['!merges'].push({
    s: { r: 0, c: 0 },
    e: { r: 0, c: colCount - 1 }
  });

  ws['A1'] = {
    v: title,
    t: 's',
    s: {
      font: { bold: true, sz: 16, color: { rgb: '000000' } },
      fill: { fgColor: { rgb: 'ffffff' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border:border
    }
  };

 for (let c = 0; c < colCount; c++) {
  const addr = XLSX.utils.encode_cell({ r: 0, c: c });

  if (!ws[addr]) ws[addr] = { v: '', t: 's' };
  if (!ws[addr].s) ws[addr].s = {};

  ws[addr].s = {
    ...ws[addr].s,
    border: border,
    alignment: { horizontal: 'center', vertical: 'center' },
    font: { bold: true, sz: 16, color: { rgb: '000000' } },
    fill: { fgColor: { rgb: 'FFFFFF' } }
  };
}

  ws['!rows'] = ws['!rows'] || [];
  ws['!rows'][0] = { hpt: 45 };

  const colWidths = exportColumns.map(col => {
    let max = col.value.length;
    exportData.forEach(row => {
      const val = row[col.value];
      if (val) max = Math.max(max, val.toString().length);
    });
    return max + 6;
  });
  ws['!cols'] = colWidths.map(w => ({ wch: w }));


  const range = XLSX.utils.decode_range(ws['!ref']!);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const addr = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[addr]) continue;
      if (!ws[addr].s) ws[addr].s = {};

      if (R === 1) {
        ws[addr].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '728FCE' } }, 
          alignment: { horizontal: 'center', vertical: 'center' },
          border
        };
      } else if (R >= 2) {
        ws[addr].s = {
          alignment: { horizontal: 'center', vertical: 'center' },
          border
        };
      }
    }
  }

  XLSX.utils.book_append_sheet(wb, ws, 'Report');
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blob, fileName);
}
}
